import React from 'react'
import { useFormState, useFormApi } from 'informed'
import { Row, Col } from 'react-flexbox-grid'
import isIP from 'validator/lib/isIP'
import { useTranslation } from 'react-i18next'

import ContentBlock, { ExpandableBlocks } from 'components/ContentBlock'
import { Text, Select, Checkbox } from 'components/forms'
import { loadAppConstants } from 'gql/query'
import Divider from 'components/Divider'
import useLocale from 'hooks/useLocale'

import listAdyenStores from './query/listAdyenStores'

const EftTerminal = ({ creditButtons = [] }) => {
	const locales = useLocale()
	const formState = useFormState()
	const formApi = useFormApi()
	const terminalType = formState?.values?.parameters?.paymentTerminal?.id || -1
	const [t, i18n] = useTranslation()
	const selectOptions = creditButtons.reduce((acc, val) => {
		if(val) {
			acc.push({ value: val.position, label: `${val.position + 1}: ${val.value}` })
		}
		return acc
	}, [])

	return(
		<ExpandableBlocks nested>
			<ContentBlock label={t('options_section.strings.eft_terminal')}>
				<Col type='row'>
					<Select
						field='parameters.paymentTerminal.id'
						label={t('options_section.strings.terminal')}
						remoteOptions={{
							query: loadAppConstants,
							variables: { type: 82, language: i18n.language },
							modifyOptions: options => options.filter(({ value }) => !['1', '2', '4', '5', '6', '7'].includes(value))
						}}
						onChange={({ value }) => {
							if(locales === 'de' && (terminalType === '8' || terminalType === '12')) {
								formApi.setValue('parameters.paymentTerminal.port', '20002')
							}else if(locales === 'de-ch' && terminalType === '8') {
								formApi.setValue('parameters.paymentTerminal.port', '4100')
							} else if((locales === 'de-ch' || locales === 'de') && terminalType === '9') {
								formApi.setValue('parameters.paymentTerminal.port', '5577')
							}
						}}
					/>
				</Col>
				<Divider/>
				{(terminalType === '10') &&
					<Row>
						<Col type='row' xs>
							<Text field='parameters.paymentTerminal.walleeApplicationKey' label={t('options_section.fields.wallee_application_key')} />
							<Text field='parameters.paymentTerminal.walleeVirtualTerminalId' label={t('options_section.fields.wallee_virtual_terminal_id')} />
							<Text field='parameters.paymentTerminal.walleeUserId' label={t('options_section.fields.wallee_user_id')} />
						</Col>
						<Col type='row' xs>
							<Text field='parameters.paymentTerminal.walleeSpaceId' label={t('options_section.fields.wallee_space_id')} />
							<Text field='parameters.paymentTerminal.walleeTerminalID' label={t('options_section.fields.wallee_terminal_id')} />
						</Col>
					</Row>
				}
				{(terminalType === '8' || terminalType === '9' || terminalType === '12' || terminalType === '13') &&
					<Col type='row'>
						<Text field='parameters.paymentTerminal.ip' label='TCP/IP' keepState validate={v => v && !isIP(v) ? t('validators.not_a_valid_ip_address') : null}/>
						<Text field='parameters.paymentTerminal.port' label={t('options_section.fields.port')} keepState />
					</Col>
				}
				{terminalType === '14' &&
					<Col type='row'>
						<Text field='parameters.paymentTerminal.adyenPoiId' label={t('options_section.fields.poiID')}/>
						<Text field='parameters.paymentTerminal.adyenLiveEndpointUrlPrefix' label={t('options_section.fields.liveEndpointUrlPrefix')}/>
						<Text field='parameters.paymentTerminal.adyenApiKey' label={t('options_section.fields.apiKey')}/>
					</Col>
				}
				{terminalType === '15' &&
					<Col type='row'>
						<Select
							field='parameters.paymentTerminal.hsPayStore'
							label={t('options_section.fields.store')}
							valueField='id'
							labelField='name'
							remoteOptions={{
								query: listAdyenStores,
								fetchPolicy: 'cache-and-network'
							}}
						/>
					</Col>
				}
				{terminalType === '16' &&
					<Col type='row'>
						<Text field='parameters.paymentTerminal.ip' label='TCP/IP' keepState validate={v => v && !isIP(v) ? t('validators.not_a_valid_ip_address') : null}/>
					</Col>
				}
				{!['7', '8', '9', '-1', '10', '11', '12', '13', '14', '15', '16'].includes(terminalType) &&
					<>
						<Divider />
						<Col type='row'>
							<Text field='parameters.paymentTerminal.serialNumber' label='TID'/>
							<Text field='parameters.paymentTerminal.posId' label='POS ID'/>
						</Col>
					</>
				}
				{terminalType !== '11' &&
					<>
						<Divider />
						<Col type='row'>
							<Checkbox field='parameters.printer.isPrintEFTReceipts' label={t('options_section.fields.auto_print_receipt_eft')} />
						</Col>
					</>
				}

				<Divider visible inverted />
				<Select
					field='parameters.paymentTerminal.creditPositionInfo.position'
					label={t('options_section.fields.link_credit_card')}
					options={selectOptions}
				/>
			</ContentBlock>
			<ContentBlock label={t('options_section.strings.glory_terminal')}>
				<Row>
					<Col xs>
						<Text field='parameters.gloryTerminalAddress' label={t('options_section.strings.localIPAdress')} />
						<Checkbox field='parameters.gloryTerminalConnected' label={t('common.fields.isActive')} />
					</Col>
					<Col xs>
						<Text field='parameters.gloryTerminalUser' label={t('common.fields.user')} />
						<Text field='parameters.gloryTerminalPassword' label={t('options_section.fields.password')} type='password' disablePasswordAutoComplete/>
					</Col>
				</Row>
			</ContentBlock>
		</ExpandableBlocks>

	)
}

export default EftTerminal
